import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp, Sizes } from '@lean-body/components/styles';
import { useSmMediaQuery } from '@lean-body/src/util/media_query_hooks';
import { Overlay } from '../organisms/overlay';
import { ArrowDirection, ArrowIconWithMargin } from '../atoms';
export const DailyLessonChangeReasonView = ({ reasons, onClickClose, onClickBackToHome, onClickReason, }) => {
    const isSM = useSmMediaQuery();
    const sortedReasons = [...reasons].sort((a, b) => a.orderIndex - b.orderIndex);
    return (React.createElement(Overlay, { background: Colors.White, top: isSM ? Sizes.MobileHeaderHeight : 0 },
        React.createElement("div", { className: css(styles.container) },
            React.createElement("div", { className: css(styles.header) },
                React.createElement("div", { className: css(styles.headerLeftButton), onClick: onClickClose },
                    React.createElement(ArrowIconWithMargin, { direction: ArrowDirection.left, color: Colors.TextDark, classObject: styles.headerLeftIcon }),
                    React.createElement("span", { className: css(styles.headerButtonText) }, "\u518D\u958B")),
                React.createElement("div", { className: css(styles.headerRightButton), onClick: onClickBackToHome },
                    React.createElement("span", { className: css(styles.headerButtonText) }, "\u30B9\u30AD\u30C3\u30D7"))),
            React.createElement("div", { className: css(styles.body) },
                React.createElement("div", { className: css(styles.titleWrap) },
                    React.createElement("div", { className: css(styles.title) }, "\u3084\u3081\u308B\u7406\u7531\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044"),
                    React.createElement("div", { className: css(styles.subTitle) }, "\u4ECA\u306E\u3042\u306A\u305F\u306B\u5408\u308F\u305B\u3066\u30EC\u30C3\u30B9\u30F3\u3092\u30C1\u30A7\u30F3\u30B8\u3057\u307E\u3059\uD83D\uDD01")),
                React.createElement("div", { className: css(styles.list) }, sortedReasons.map((reason) => (React.createElement("div", { key: reason.changeReason, className: css(styles.chip), onClick: () => onClickReason(reason) }, reason.content))))))));
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 42,
    },
    headerLeftButton: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '10px 6px 10px 16px',
        cursor: 'pointer',
    },
    headerLeftIcon: {
        width: 24,
        height: 24,
    },
    headerRightButton: {
        padding: '10px 16px 10px 6px',
        cursor: 'pointer',
    },
    headerButtonText: {
        color: Colors.TextDark,
        fontSize: 15,
        fontWeight: 500,
        lineHeight: '100%',
        letterSpacing: '0.6px',
    },
    body: {
        padding: '16px 36px 36px',
        [MediaBreakPointUp.MD]: {
            maxWidth: 375,
            margin: '0 auto',
        },
    },
    titleWrap: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 18,
        marginBottom: 40,
    },
    title: {
        color: Colors.TextDark,
        fontSize: 20,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: '1.6px',
        textAlign: 'center',
    },
    subTitle: {
        color: Colors.GrayDarkest,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '140%',
        letterSpacing: '0.56px',
        textAlign: 'center',
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    chip: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: 68,
        backgroundColor: Colors.White,
        border: `1px solid ${Colors.Gray}`,
        borderRadius: 10,
        color: Colors.Black,
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: '0.56px',
        cursor: 'pointer',
        textAlign: 'center',
    },
});
